/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'

function GridCard({title, message, date, authorName}: any) {
  const [noteModalOpen, setNoteModalOpen] = useState(false)
  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
      return text
    } else {
      return text.slice(0, maxLength) + '...'
    }
  }
  // Note form
  const openModal = () => {
    setNoteModalOpen(true)
  }
  const closeModal = () => {
    setNoteModalOpen(false)
  }
  return (
    <div className='card-xl-stretch mx-md-3'>
      <div className='m-0'>
        <div className='fs-6 fw-bold pb-3'>
          <span className='text-muted'>{date}</span>
        </div>
        <a
          onClick={openModal}
          className='fs-5 text-dark fw-bold text-hover-primary text-dark lh-base cursor-pointer'
        >
          {title}
        </a>
        <div style={{height: 100}} className='fw-semibold fs-5 text-gray-600 text-dark my-4 '>
          <div dangerouslySetInnerHTML={{__html: truncateText(message, 100)}} />
        </div>
      </div>
      <div style={{textAlign: 'end'}} className='fs-6 fw-bold'>
        <span className='text-muted'>{authorName}</span>
      </div>

      {/* MODAL => Note */}
      {noteModalOpen && (
        <div
          className='modal'
          tabIndex={-1}
          role='dialog'
          style={{display: 'block', width: '100%'}}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'  style={{minHeight:500}}>
              <div className='modal-header'>
                <h5 className='modal-title'>Note Details</h5>
                <button type='button' className='btn-close' onClick={closeModal}>
                  {/* <span>&times;</span> */}
                </button>
              </div>

              <div className='modal-body'>
                <div className='form-group d-flex'>
                  <label
                    htmlFor='title'
                    className='fs-5 fw-bold align-self-center w-20'
                    style={{width: '20%'}}
                  >
                    Note Title:
                  </label>
                  <p className='fs-5 s text-dark fw-bold text-hover-primary text-dark lh-base mt-4'>
                    {title}
                  </p>
                </div>
                  <div
                    className='fw-semibold fs-5 text-gray-600 text-dark my-4 text-justify'
                  >
                    <div dangerouslySetInnerHTML={{__html: truncateText(message, 10000)}} />
                  </div>
                
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default GridCard
